import { defineComponent as _defineComponent } from 'vue'
import SubNavigation from '@/ui/chrome/menu/SubNavigation.vue';
import { computed, ref, watch, onMounted, nextTick } from 'vue';
import { store } from '@/store';
import mainnavigationService from '../mainnavigation.service';


export default /*#__PURE__*/_defineComponent({
  __name: 'MainMenuItem',
  props: {
    mainNavigationItem: null,
    measurements: null,
    popoutOpen: { type: Boolean },
    first: { type: Boolean }
  },
  emits: ["toggleMegaMenuPopout", "closeSubmenu"],
  setup(__props: any, { emit }: { emit: ({(e: 'toggleMegaMenuPopout', value: boolean) : void, (e: 'closeSubmenu') : void}), expose: any, slots: any, attrs: any }) {

const props = __props as {
    mainNavigationItem?: INavigationViewObject,
    measurements?: MegamenuMeasurements,
    popoutOpen?: boolean,
    first?: boolean
}




const showAuthTopBar = computed<boolean>(() => store.getters['app/showAuthTopBar']);
const showEmptyTopBar = computed<boolean>(() => store.getters['app/showEmptyTopBar']);
const navLink = ref<HTMLElement | null>(null);
const subNavigationWrapper = ref<HTMLDivElement | null>(null);
const active = ref<boolean>(false);
const hasChildren = computed<boolean>(() => {
    return props.mainNavigationItem.submenu && props.mainNavigationItem.submenu.length > 0;
});
const openSubNavigation = ref<boolean>(false);
const openState = computed<boolean>(() => {
    return openSubNavigation.value && props.popoutOpen;
});
function onOpenStateChange() {
    setTimeout(() => {
        if (openState.value) {
            emit('toggleMegaMenuPopout', true);
        }
    }, 10);
}
watch(openState, onOpenStateChange);
function onMouseEnter() {
    if (!hasChildren.value) {
        emit('toggleMegaMenuPopout', false);
        return;
    }
    openSubNavigation.value = true;
    emit('toggleMegaMenuPopout', true);
}


function handleKeydown(event: KeyboardEvent) {
    if (event.key === 'ArrowDown' ) {

        event.preventDefault();

        const wrapper = subNavigationWrapper.value;
        if (wrapper) {
            const tabbableItems = wrapper.querySelectorAll('[tabindex="-1"]');
            tabbableItems.forEach((el: Element) => {
                (el as HTMLElement).setAttribute('tabindex', '0');
            });
        }
        nextTick(() => {
            setTimeout(() => {
                const firstFocusable = subNavigationWrapper.value.querySelector(
                    'a'
                ) as HTMLElement;
                if (firstFocusable) {
                    firstFocusable.focus();         
                }
            }, 100);
        });
    }
    if (event.key === 'Escape') {
        closeSubmenu();
    }
}

function handleFocusOut(event: FocusEvent) {
    const nextFocused = event.relatedTarget as Node;
    const submenu = subNavigationWrapper.value;

    // If the next focused element is NOT inside the submenu
    if (submenu && !submenu.contains(nextFocused)) {
        closeSubmenu();
    }
}

function onMouseLeave() {
    openSubNavigation.value = false;
    active.value = false;
}

function onItemEnter() {
    active.value = true;
}

function focusNavLink() {
    nextTick(() => {
        (navLink.value as any)?.$el?.focus?.();
    });
}


function onCloseSubmenu() {
    onMouseLeave();
    emit('closeSubmenu');
    emit('toggleMegaMenuPopout', false);
}

function closeSubmenu() {
    onMouseLeave();
    onCloseSubmenu();
}

return { __sfc: true,props, emit, showAuthTopBar, showEmptyTopBar, navLink, subNavigationWrapper, active, hasChildren, openSubNavigation, openState, onOpenStateChange, onMouseEnter, handleKeydown, handleFocusOut, onMouseLeave, onItemEnter, focusNavLink, onCloseSubmenu, closeSubmenu, SubNavigation }
}

})